"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf4 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _eventEmitter = _interopRequireDefault(require("../Base/views/eventEmitter.c"));

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var onModelChangeDefault = function onModelChangeDefault() {
  return {
    __connectIterationId: (0, _uniqueId2["default"])('connectIterationId')
  };
};

var ConnectModel =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(ConnectModel, _EventEmitter);

  function ConnectModel() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ConnectModel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf4["default"])(ConnectModel)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_bind", function () {
      if (_this.Storage) {
        if (_this.attribute) {
          _this.listenTo(_this.Storage, "change:".concat(_this.attribute), _this._handleModelChange);
        } else {
          _this.listenTo(_this.Storage, 'change', _this._handleModelChange);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleModelChange", function () {
      _this._updateStorage();
    });
    return _this;
  }

  (0, _createClass2["default"])(ConnectModel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var updateStorage = false;

      if (this.props.storage && this.Storage !== this.props.storage) {
        this.Storage = this.props.storage;
        updateStorage = true;
      }

      if (this.props.attribute && this.attribute !== this.props.attribute) {
        this.attribute = this.props.attribute;
        updateStorage = true;
      }

      if (updateStorage) {
        this._rebind();

        this._updateStorage();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Class properties of child class are assign after instance creating
      // Storage, attribute, ComponentToWrap are empty in ConnectModel constructor
      if (!this.Storage && this.props.storage) {
        this.Storage = this.props.storage;
      }

      if (!this.attribute && this.props.attribute) {
        this.attribute = this.props.attribute;
      }

      this.setState(this._getState(), this._bind);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unbind();
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof this.ComponentToWrap === 'function') {
        var Component = this.ComponentToWrap; // this.props.storage is assign to this.Storage in cdm and cdu
        // not constructor because of Storage is not defined yet
        // not cwn because of deprecation
        // this.props.storage is passed to children only for initial render before cmd processing

        return _react["default"].createElement(Component, (0, _extends2["default"])({}, this.props, {
          model: this.Storage || this.props.storage
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "_getState",
    value: function _getState() {
      return onModelChangeDefault();
    }
  }, {
    key: "_unbind",
    value: function _unbind() {
      if (this.Storage) {
        this.stopListening(this.Storage);
      }
    }
  }, {
    key: "_updateStorage",
    value: function _updateStorage() {
      return this.setState(this._getState());
    }
  }]);
  return ConnectModel;
}(_eventEmitter["default"]);

var connectFabric = function connectFabric(Component, Storage, attribute) {
  var _class, _temp;

  if (typeof Component !== 'function') {
    if (process && process.env.NODE_ENV !== 'production') {
      window.console.error("connectModel: cannot connect Constructor.");
    }

    return null;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_ConnectModel) {
    (0, _inherits2["default"])(_class, _ConnectModel);

    function _class() {
      var _getPrototypeOf3;

      var _this2;

      (0, _classCallCheck2["default"])(this, _class);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf3 = (0, _getPrototypeOf4["default"])(_class)).call.apply(_getPrototypeOf3, [this].concat(args)));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "ComponentToWrap", Component);
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "Storage", Storage);
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "attribute", attribute);
      return _this2;
    }

    return _class;
  }(ConnectModel), (0, _defineProperty2["default"])(_class, "displayName", "ConnectModel(".concat(Component.displayName || '', ")")), _temp;
};

function _default(Storage, attribute) {
  return function (Component) {
    return connectFabric(Component, Storage, attribute);
  };
}